<template>
    <div class="flex-n fac z-little-card">
        <svg class="iconfont" aria-hidden="true">
            <use v-bind:xlink:href="'#'+icon"></use>
        </svg>
        <div class="right">
            <div class="title">{{title}}</div>
            <div class="num textnowrap">{{num}}</div>
            <div class="flex-w fac subtitle" v-if="subtitle"><div class="mr-10">{{subtitle}}&nbsp;&nbsp;{{subnum}}</div><div>{{subtitle2}}&nbsp;&nbsp;{{subnum2}}</div></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "z-little-card",
        props:{
            icon:String,
            title:String,
            num:Number|String,
            subtitle:String,
            subnum:Number|String,
            subtitle2:String,
            subnum2:Number|String,
        }
    }
</script>

<style scoped lang="scss">
    .z-little-card{
        margin-top: 20px;
        height: 144px;
        padding: 0 20px;
        border: 1px solid #e9e9e9;
        background: white;
        .iconfont{
            font-size: 100px;
            width: 100px;
            height: 100px;
        }
        .right{
            flex: 1;
            margin-left: 20px;
            .title{
                font-size: 14px;
                color: #aaaaaa;
            }
            .num{
                font-size: 30px;
                color: #666;
                height: 60px;
            }
            .subtitle{
                border-top: 1px solid #ddd;
                color: #999999;
                font-size: 14px;
            }
        }
    }

</style>